import { PropTypes } from "prop-types"

import Modal from "../Modal"

import LoaderSection from "./LoaderSection"

function Loader({ textKey, textParams, show = false }) {
  return (
    <Modal
      cssClassName="oj-loader"
      isOpen={show}
      shouldFocusAfterRender={show}
      shouldReturnFocusAfterClose={show}
    >
      <LoaderSection textKey={textKey} textParams={textParams} />
    </Modal>
  )
}
Loader.displayName = "Loader"

Loader.propTypes = {
  show: PropTypes.bool,
  textKey: PropTypes.string,
  textParams: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
}

export default Loader
